import {
    ClaimHide,
    ColoursObj,
    Icon,
    TEventrIcons,
    Typography,
} from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { CountLabel } from '../../../common/CountLabel'

interface ISectionButtonProps {
    claims?: string[]
    claimPaths?: string[]
    elementID: string
    onClick: () => void
    icon: TEventrIcons
    text: string
    count?: number
    colour?: string
}
export const SectionButton = ({
    claims,
    claimPaths,
    elementID,
    onClick,
    icon,
    text,
    count,
    colour,
}: ISectionButtonProps) => {
    return (
        <ClaimHide paths={claimPaths} claims={claims}>
            <div id={elementID} onClick={onClick}>
                <Stack
                    paddingY="16px"
                    paddingX="8px"
                    borderBottom={'1px solid ' + ColoursObj.shades.shade3}
                >
                    <Stack
                        direction="row"
                        padding="8px"
                        justifyContent="space-between"
                        onClick={() => {}}
                    >
                        <Stack direction="row" spacing="16px">
                            <Icon iconColour={colour} name={icon} />

                            <Typography
                                variant="bodyBold"
                                color={colour ?? ColoursObj.core.primary}
                            >
                                {text}
                            </Typography>
                        </Stack>

                        <Stack direction="row" spacing="8px">
                            {count > 0 && (
                                <CountLabel
                                    id={elementID + 'Count'}
                                    text={count}
                                />
                            )}

                            <Icon iconColour={colour} name="Chevron_Right" />
                        </Stack>
                    </Stack>
                </Stack>
            </div>
        </ClaimHide>
    )
}
